import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle
    , Grid, TextField, Typography, Hidden } from '@mui/material';
import { DataGrid, GridToolbarContainer, GridOverlay } from "@mui/x-data-grid";
import { Search as IconSearch } from "@mui/icons-material";
import React, { useState } from 'react';
import { PaperComponentDraggable } from "./PaperComponentDraggable";
import * as personaService from "../services/personaService";

// Busqueda de terapeutas, para elegir quien hace la evaluacion.
const TerapeutaSearch = (props) => {
    const [filters, setFilters] = useState({
        name: "",
    });
    const [results, setResults] = useState([]);
    // Fila resaltada con un clic. Se elige con doble clic o con Aceptar.
    const [filaElegida, setFilaElegida] = useState(null);
    const [cargando, setCargando] = useState(false);

    const fetchResults = async () => {
        setCargando(true);

        // Tipo de persona 25: terapeuta.
        const data = await personaService.getsListNaturalPersonByTypeAndName(25, filters.name)
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        setResults(data || []);
        setFilaElegida(null);
        setCargando(false);
    }

    React.useEffect(() => {
        fetchResults();
    }, [])

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
            </GridToolbarContainer>
        );
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 80, sortable: false },
        { field: 'descripcion', headerName: 'Terapeuta', width: 250, sortable: true },
    ];

    return (
        <Dialog
            open={props.open}
            onClose={props.openClose}
            fullWidth={true}
            maxWidth={"sm"}
            PaperComponent={PaperComponentDraggable}
        >
            <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
                <Typography>Buscar Terapeuta</Typography>
            </DialogTitle>
            <DialogContent style={{ minHeight: "350px", maxHeight: "400px" }}>
                <Grid container item xs={12} sm={12} spacing={1} padding={1}>
                    <Grid item xs={8} sm={9}>
                        <TextField
                            name="name"
                            label="Nombre"
                            value={filters.name}
                            fullWidth
                            onChange={(event) => {
                                setFilters({ ...filters, name: event.target.value })
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Button variant="outlined" onClick={() => { fetchResults() }} fullWidth>
                            {<Hidden smDown>Buscar</Hidden>}
                            <IconSearch />
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <DataGrid
                            rows={results}
                            columns={columns}
                            initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
                            pageSize={5}
                            pageSizeOptions={[5, 10]}
                            disableColumnMenu
                            components={{ Toolbar: CustomToolbar, LoadingOverlay: () => (
                                <GridOverlay><CircularProgress /></GridOverlay>
                            ) }}
                            loading={cargando}
                            rowHeight={25}
                            disableRowSelectionOnClick={false}
                            onRowClick={(params) => setFilaElegida(params.row)}
                            onRowDoubleClick={(params) => {
                                props.setSelection(params.row);
                                props.openClose();
                            }}
                            autoHeight={true}
                            sx={{ "& .MuiDataGrid-columnHeader ": { backgroundColor: "#1976d2", color: "white" } }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="primary" disabled={!filaElegida} onClick={() => {
                    if (filaElegida) {
                        props.setSelection(filaElegida);
                        props.openClose()
                    }
                }}>Aceptar</Button>
                <Button onClick={() => { props.openClose() }} >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default TerapeutaSearch;
